"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "saludecio": {
    "7b8815b5": [{
      "hkey": "624f25eb",
      "slug": "cerreto-castello",
      "name": "Cerreto Castello",
      "primary": true,
      "skipSearch": false
    }],
    "cerreto": [{
      "hkey": "624f25eb",
      "slug": "cerreto-castello",
      "name": "Cerreto Castello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "f2bb0095": [{
      "hkey": "847df830",
      "slug": "saludecio",
      "name": "Saludecio",
      "primary": true,
      "skipSearch": false
    }],
    "san-rocco": [{
      "hkey": "847df830",
      "slug": "saludecio",
      "name": "Saludecio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;